import React, { useEffect } from "react"
import { Container, Row, Col } from "reactstrap"
import MetaTags from "react-meta-tags"
import PropTypes from 'prop-types';
import CenterModal from "../../components/Common/CenterModal";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

//Import Components

import axios from 'axios';
import { useQuery } from 'react-query';
import { Link } from "react-router-dom";
import { Table, Card, CardBody } from "reactstrap";
import SimpleBar from 'simplebar-react';
import { inviteCustomer } from "helpers/fakebackend_helper";
import { useMutation } from 'react-query';

const InviteCustomerFrom = ({ closeModal }) => {

  const [email, setEmail] = React.useState('');
  const [name, setName] = React.useState('');
  const [role, setRole] = React.useState('');
  const [loading, setLoading] = React.useState(false);


  const { mutate } = useMutation(inviteCustomer, {
    onSuccess: (data) => {
      
      console.log("Messages fetched successfully:", data);
      closeModal();
      setLoading(false);
    },
    onError: (error) => {
      console.error("Error fetching messages:", error);
      setLoading(false);
    },
  });

  const handleInvite = async () => {
    setLoading(true);
    try {
      await mutate( { email: email, name: name , role: role });
    } catch (error) {
      console.error("Error inviting customer:", error);
      setLoading(false);
    }
  }

  return (
    <div>
      <form>
        <div className="mb-3">
          <label htmlFor="email" className="form-label">
            Email
          </label>
          <input type="email" className="form-control" id="email" onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="mb-3">
          <label htmlFor="name" className="form-label">
            Name
          </label>
          <input type="text" className="form-control" id="name" onChange={(e) => setName(e.target.value)} />
        </div>
        <div className="mb-3">
          <label htmlFor="role" className="form-label">
            Role
          </label>
          <select className="form-select" id="role" onChange={(e) => setRole(e.target.value)}>
            <option value="">Select Role</option>
            <option value="lawyers">Lawyers</option>
            <option value="mediators">Mediators</option>
            <option value="parenting_coordinators">Parenting Coordinators</option>
            <option value="parents">Parents</option>
            <option value="therapists">Therapists</option>
          </select>
        </div>
      </form>
      <div className="text-end">
        <button className="btn btn-primary" onClick={handleInvite} disabled={loading}>
          {loading ? 'Inviting...' : 'Invite'}
        </button>
      </div>
      {loading && <div className="spinner-border" role="status"><span className="visually-hidden">Loading...</span></div>}
    </div>
  );
};

InviteCustomerFrom.propTypes = {
  closeModal: PropTypes.func.isRequired,
};
            

const ParentingSpaces = props => {

  const [inviteModalOpen, setInviteModalOpen] = React.useState(false);
  const toggleinviteModal = () => setInviteModalOpen(!inviteModalOpen);
  const closeinviteModal = () => setInviteModalOpen(false);


    const { data, error, isLoading } = useQuery('productList', async () => {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/admin/get-parenting-spaces-owners/`,
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        });
        return response.data;
      });
  
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>
          Beaconparenting Admin
          </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Parenting Spaces" breadcrumbItem="" />
        
          <Card>
      <CardBody>
        <div className="d-flex justify-content-between">
          <h4 className="card-title mb-4">Customer Space List</h4>

        </div>

        <div className="my-5">
          <button 
            onClick={toggleinviteModal}
          className="btn btn-primary">Invite Customer</button>
        </div>

        <CenterModal
            isOpen={inviteModalOpen}
            toggle={toggleinviteModal}
            title="Invite Customer"
          >
            <InviteCustomerFrom closeModal={closeinviteModal} />
          </CenterModal>

        <div className="table-responsive">
        <SimpleBar style={{ maxHeight: 500 }}>

          <Table className="table table-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">Parenting Space </th>
                <th scope="col">Created At</th>
                <th scope="col" colSpan="2">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="8" className="text-center">
                    <div className="spinner-border spinner-border-sm" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </td>
                </tr>
              ) : 
              (
                data?.map((parentingSpace) => (
                  <tr key={parentingSpace.id}>
                    <td>{parentingSpace?.owner?.name}</td>
                    <td>{parentingSpace?.owner?.email}</td>
                    <td>{parentingSpace?.name}</td>
                    <td>{new Date(parentingSpace?.created_at).toLocaleDateString()}</td>
                    <td>
                      <Link to={`parenting-menu/${parentingSpace.id}`} >
                        <button 
                        className="btn btn-primary" 
                      >
                        Go to Space
                      </button>
                      </Link>
                  
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
          </SimpleBar >

        </div>
      </CardBody>
      
    </Card>
          
        </Container>
      </div>
    </React.Fragment>
  )
}



export default ParentingSpaces
